(function () {
  const REQUIRED_CLICKS = 10;
  const RESET_DELAY_MS = 2000;
  const MOBILE_QUERY = '(max-width: 48em)';

  const triggers = Array.from(document.querySelectorAll('.humm-easter-egg-trigger'));
  if (!triggers.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobileQuery = window.matchMedia(MOBILE_QUERY);

  let clickCount = 0;
  let resetTimer = null;
  let isAnimating = false;

  const isMobile = () => mobileQuery.matches;

  const resetCounter = () => {
    clickCount = 0;
    if (resetTimer) {
      clearTimeout(resetTimer);
      resetTimer = null;
    }
  };

  const scheduleReset = () => {
    if (resetTimer) clearTimeout(resetTimer);
    resetTimer = setTimeout(resetCounter, RESET_DELAY_MS);
  };

  const removeFloat = (el) => {
    el.remove();
    isAnimating = false;
  };

  const spawnImage = (src) => {
    if (isAnimating || prefersReducedMotion || !src) return;

    isAnimating = true;

    const float = document.createElement('div');
    float.className = 'humm-easter-egg-float';

    const img = document.createElement('img');
    img.src = src;
    img.alt = '';
    img.decoding = 'async';

    float.appendChild(img);
    document.body.appendChild(float);

    const onDone = () => {
      float.removeEventListener('animationend', onDone);
      removeFloat(float);
    };

    float.addEventListener('animationend', onDone);

    img.addEventListener('error', () => {
      float.removeEventListener('animationend', onDone);
      removeFloat(float);
    });
  };

  const handleActivate = (trigger, event) => {
    if (!isMobile()) return;

    event.preventDefault();
    event.stopPropagation();

    if (isAnimating) return;

    clickCount += 1;
    scheduleReset();

    if (clickCount < REQUIRED_CLICKS) return;

    const src = trigger.dataset.easterEggImage;
    resetCounter();
    spawnImage(src);
  };

  triggers.forEach((trigger) => {
    let touchHandled = false;

    trigger.addEventListener('selectstart', (event) => event.preventDefault());

    trigger.addEventListener(
      'touchstart',
      (event) => {
        if (!isMobile()) return;
        event.preventDefault();
      },
      { passive: false }
    );

    trigger.addEventListener(
      'touchend',
      (event) => {
        if (!isMobile()) return;
        event.preventDefault();
        touchHandled = true;
        handleActivate(trigger, event);
        setTimeout(() => {
          touchHandled = false;
        }, 400);
      },
      { passive: false }
    );

    trigger.addEventListener('click', (event) => {
      if (!isMobile()) return;
      event.preventDefault();
      if (touchHandled) return;
      handleActivate(trigger, event);
    });
  });

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('.humm-easter-egg-trigger')) return;
      resetCounter();
    },
    true
  );
})();
